export default __webpack_public_path__ + "static/media/not-found.128fae0c.png";